export const ITEM_DOCUMENT_DROP_DOWN_ITEMS = []